import React, { useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  CircularProgress,
  MenuItem,
  TextField,
  Tabs,
  Tab,
} from "@mui/material";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import { useTranslation } from "react-i18next";
import back from "../../../assets/back.svg";
import LogoutModal from "./Logout";
import logoutmodel from "../../../assets/logoutmodel.svg";
import ChangePasswordSettings from "./changePassword";
import { useNavigate } from "react-router-dom";
const GeneralSetting = ({ onBack }) => {
  const { t, i18n } = useTranslation();
 const [language, setLanguage] = useState(i18n.language);
 const navigate=useNavigate()
  const [openModal, setOpenModal] = useState(false);
  const [pendingLang, setPendingLang] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0); // 0 = language, 1 = change password
  const [passwordOpen, setPasswordOpen] = useState(true); // control password modal

  const languageOptions = [
    { label: "English", value: "en" },
    { label: "Español", value: "es" },
  ];

  const handleLanguageChange = (value) => {
    if (value !== language) {
      setPendingLang(value);
      setOpenModal(true);
    }
  };

  const confirmChange = async () => {
    setLoading(true);
    try {
      if (pendingLang) {
        setLanguage(pendingLang);
        await i18n.changeLanguage(pendingLang);
      }
    } finally {
      setLoading(false);
      setOpenModal(false);
      setPendingLang(null);
    }
  };

  return (
    <>
      {/* Top back bar */}
      <Box
        sx={{
          borderRadius: 2,
          px: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          minHeight: 55,
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1.5, cursor: "pointer" }}
         onClick={() => navigate(-1)}
        >
          <img src={back} style={{ width: 30, height: 30 }} alt="back" />
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 500,
              fontSize: "14px",
              color: "#626F86",
              textAlign: "center",
            }}
          >
            {t("general_setting_screen.breadcrumb")}
          </CustomText>
        </Box>
      </Box>

      {/* Tabs */}
      <Box sx={{ width: "100%", maxWidth: 800, mx: "auto", mb: 3,backgroundColor:"white", p:1,borderRadius:1, }}>
<Tabs
  value={activeTab}
  onChange={(e, val) => {
    setActiveTab(val);
    if (val === 1) {
      setPasswordOpen(true); // <-- always open modal when tab is clicked
    }
  }}
  textColor="primary"
  indicatorColor="primary"
  sx={{
    "& .MuiTab-root": {
      fontSize: "14px",
      textTransform: "none",
      fontWeight: 500,
      fontFamily: "Poppins, sans-serif",
    },
  }}
>
  <Tab label={t("tabs.languageSwitch")} />
  {/* <Tab label={t("tabs.changePassword")} /> */}
</Tabs>

      </Box>

      {/* Tab content */}
      {activeTab === 0 && (
        <Box
          sx={{
            width: "100%",
            maxWidth: 500,
            mx: "auto",
            backgroundColor: "white",
            px: 2,
            borderRadius: 2,
            py: 3,
          }}
        >
          <Box mb={2}>
            <label className="field_label">
              {t("general_setting_screen.defaultLanguageLabel")}
            </label>
            <TextField
              select
              fullWidth
              size="small"
              value={language}
              onChange={(e) => handleLanguageChange(e.target.value)}
              sx={{
                fontFamily: "Poppins, sans-serif",
                fontSize: "15px",
                mt: 1,
                borderRadius: "10px",
                "& .MuiOutlinedInput-root": {
                  height: "40px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "2px solid #091E4224",
                },
                "& .MuiSelect-select, & .MuiInputBase-input": {
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "15px",
                },
              }}
            >
              {languageOptions.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "15px",
                  }}
                >
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Box>
      )}

      {activeTab === 1 && (
        <ChangePasswordSettings open={passwordOpen} onClose={() => setPasswordOpen(false)} />
      )}

      {/* Confirm Modal */}
      <Dialog
        open={openModal}
        onClose={() => !loading && setOpenModal(false)}
        fullWidth
        maxWidth="sm"
        keepMounted
        disableEscapeKeyDown={loading}
        PaperProps={{
          sx: {
            borderRadius: 3,
            textAlign: "center",
              p: { xs: 0.5, sm: 2,md:2,lg:2 },
            py: 1,
          },
        }}
        BackdropProps={{
          sx: { backdropFilter: "blur(1px)" },
        }}
      >
        <DialogContent sx={{ pt: 3 }}>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 1.5 }}>
            <img
              src={logoutmodel}
              alt="language change"
              style={{ width: 50, height: 50 }}
            />
          </Box>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "32px",
              color: "#2C384C",
            }}
          >
         {t("Are you sure you want to change language to Español?")}
          </CustomText>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "center",
            gap: 1.5,
            pb: 2.5,
            pt: 0,
          }}
        >
          <CustomButton
            onClick={() => setOpenModal(false)}
            disabled={loading}
            size="medium"
            label={t("logoutModel.cancel")}
            sx={{
              color: "#172B4D",
              backgroundColor: "white",
              "&:hover": {
                backgroundColor: "white",
                color: "#172B4D",
              },
            }}
          />
          <CustomButton
            onClick={confirmChange}
            disabled={loading}
            size="medium"
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {loading && (
                  <CircularProgress
                    size={18}
                    thickness={4}
                    sx={{ color: "#ffffff" }}
                  />
                )}
                Yes
              </Box>
            }
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GeneralSetting;
